<!-- FOOTER -->
<footer>

  <!-- CONTAINER -->
  <div class="container">

    <!-- ROW -->
    <div class="row" data-appear-top-offset="-200" data-animated="fadeInUp">

      <div class="col-lg-3 col-md-3 col-sm-6 padbot30">
        <h4><b>Apoios</b></h4>
        <div class="apoios">
          <ul>
            <li><a href="http://www5.each.usp.br/web/prof/menna/" target="_blank"><img src="/assets/images/gmdrb.png" alt=""></a></li>
            <li><a href="http://cnpq.br" target="_blank"><img src="/assets/images/cnpq.png" alt=""></a></li>
            <li><a href="http://usp.br" target="_blank"><img src="/assets/images/usp.png" alt=""></a></li>
          </ul>
        </div>
      </div>

      <div class="col-lg-5 col-md-5 col-sm-6 padbot30 foot_about_block">
        <h4><b>Sobre</b> nós</h4>
        <p>Somos movidos pelo desafio de desenvolver projetos de pesquisa envolvendo a Cronobiologia com as áreas de Artes, Ciências e Humanidades, capazes de impulsionar o desenvolvimento e promover uma forte interação com a sociedade, e em especial as comunidades da zona leste de São Paulo.</p>
      </div>

      <div class="respond_clear"></div>

      <div class="col-lg-4 col-md-4 padbot30">
        <!--h4><b>Fale</b> conosco</h4>

        <!-- CONTACT FORM >
        <div class="span9 contact_form">
          <div id="note"></div>
          <div id="fields">
            <form id="contact-form-face" class="clearfix" action="#">
              <input type="text" name="name" value="" placeholder="Nome" />
              <textarea name="message" placeholder="Mensagem"></textarea>
              <input class="contact_btn" type="submit" value="Enviar" />
            </form>
          </div>
        </div><!-- //CONTACT FORM -->
      </div>
    </div><!-- //ROW -->
  </div><!-- //CONTAINER -->
</footer><!-- //FOOTER -->
